import * as R from 'ramda'
import {
  RESET_EMPLOYEE_IMAGE,
  UPDATE_EMPLOYEE_IMAGE,
} from './constants'

import { createReducer } from 'helpers/ReducerUtil'

const updateEmployeeImage = (prevImg, { img }) => R.merge(prevImg, img)

const employeeImageReducer = createReducer({}, {
  [RESET_EMPLOYEE_IMAGE]: () => ({}),
  [UPDATE_EMPLOYEE_IMAGE]: updateEmployeeImage
})

export default employeeImageReducer
